export default "__VITE_ASSET__Dc6QOkqw__"